import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: 'Cancel',
  submit: 'Submit'
});
